import React from 'react';
import styles from './StatCard.module.css';

export interface StatCardProps {
  label: string;
  value: string;
  sub?: string;
  tone?: 'default' | 'green' | 'red';
}

const StatCard: React.FC<StatCardProps> = ({ label, value, sub, tone = 'default' }) => (
  <div className={styles.card}>
    <div className={styles.label}>{label}</div>
    <div className={`${styles.value} ${tone === 'green' ? styles.green : tone === 'red' ? styles.red : ''}`}>{value}</div>
    {sub && <div className={styles.sub}>{sub}</div>}
  </div>
);

export default StatCard;
